<template>
  <svg viewBox="0 0 135 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0V6.66667H6.63065V20H13.2613V0H0Z" fill="white" />
    <path
      d="M17.9028 6.66667C19.7338 6.66667 21.2181 5.17428 21.2181 3.33333C21.2181 1.49238 19.7338 0 17.9028 0C16.0717 0 14.5874 1.49238 14.5874 3.33333C14.5874 5.17428 16.0717 6.66667 17.9028 6.66667Z"
      fill="white"
    />
    <path
      d="M43.993 10.376C46.3721 9.864 48.3242 8.30667 48.3242 5.64533V5.40267C48.3242 3.01067 47.3879 0 39.9563 0H25.1965V20H31.5858V13.4933H38.296C40.866 13.4933 41.8686 14.2827 42.0171 16.3973V19.9973H48.4806V15.3467C48.4806 12.336 46.6347 10.8853 43.9877 10.3733L43.993 10.376ZM41.667 6.66667C41.667 7.688 41.1578 8.576 39.0996 8.576H31.5858V4.78667H39.0996C41.1578 4.78667 41.667 5.648 41.667 6.61333V6.66667Z"
      fill="white"
    />
    <path d="M58.8324 0H52.4431V20H58.8324V0Z" fill="white" />
    <path
      d="M81.8991 8.952C83.395 8.736 85.668 7.55467 85.668 4.94667V4.704C85.668 2.312 84.0899 0 78.3955 0H62.8082V20H78.4485C84.8909 20 86.7103 17.1787 86.7103 14.1653V13.896C86.7103 10.5627 84.0634 9.272 81.8965 8.94933L81.8991 8.952ZM69.2001 4.43467H76.9527C78.5308 4.43467 79.0373 5.10667 79.0373 6.02133V6.07467C79.0373 6.96267 78.5573 7.66133 76.9527 7.66133H69.2001V4.43467ZM79.8144 13.5467C79.8144 14.4347 79.3874 15.3467 77.4619 15.3467H69.2001V11.7973H77.4619C79.3874 11.7973 79.8144 12.5493 79.8144 13.4373V13.5467Z"
      fill="white"
    />
    <path
      d="M96.8923 0L87.8561 20H94.2454L95.7704 16.5333H106.279L107.83 20H114.649L105.316 0H96.8923ZM97.7225 12.1227L100.985 4.65067L104.327 12.1227H97.7225Z"
      fill="white"
    />
    <path
      d="M123.022 14.784V0H116.633V20H135.056V14.784H123.022Z"
      fill="white"
    />
  </svg>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    cms: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      loading: 'loading/isLoading',
    }),
  },
}
</script>
